/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
//   import config from "../config/printShelf.config.json";
import axios from "axios";
import { LoggerModule } from "@vlinder-web/logger-module-react";

import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { PRINT_SHELF } from "../graphql";
import { VApplication } from "../../../application";
import moment from "moment-timezone";
import { StorageModule } from "@vlinder-web/storage-module-react";

const log: any = LoggerModule?.getInstance();
const storageService = StorageModule.getInstance();

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IPrintShelfShelfMethods extends IPluginMethodMap {
  printShelf(args: any): Promise<any>;
}

export class PrintShelfService implements IAgentPlugin {
  readonly methods: IPrintShelfShelfMethods;

  constructor() {
    this.methods = {
      printShelf: this.printShelf.bind(this),
    };
  }

  async printShelf(args: any) {
    log.blue(`printShelf server component:`, args);
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    try {
      // return {...config}
      if (client) {
        const res = await client.query({
          query: PRINT_SHELF,
          variables: {
            filter: {
              ...args,
            },
          },
          fetchPolicy: "network-only",
        });
        if (res?.data) {
          log.blue(`printShelf server component res?.data:`, res?.data);
          return res?.data?.getShelfPDF;
        }
      }
    } catch (err: any) {
      console.log(`error in table data`, err);
      // return {
      //   isEmpty: true,
      // };
    }
  }
}
